export default __webpack_public_path__ + "static/media/boshi.a97b596d.png";